import { h, Component } from 'preact'
import { connect } from 'react-redux'
import reduce from '../reducers'
import store from '../store'
import * as actions from '../actions'

import Renderer from '../canvas/renderer'
import util from '../util'
import constants from '../constants'

export default @connect(reduce, actions)
class PageBar extends Component {
  constructor() {
    super()
  }

  render(props, state) {
    return (
      <div class="context-bar">
        <ul>
          {/* <li>
            {!props.isMobileVersion && <a style="width: 80px; flex-direction: row-reverse" onClick={() => this.openColorPicker()}>
              <span style="margin-right: auto;" className='lbl'>Fill</span>
              <span className="color-box" style={`background: ${this.backgroundCss()}; float: none;`}></span>
            </a>}
            {props.isMobileVersion && <a className="mobile-tool-widget" onClick={() => this.openColorPicker()}>
              <span className="color-box" style={`background: ${this.backgroundCss()};`}></span>
              <span>Fill</span>
            </a>}
          </li> */}
        </ul>
      </div>
    )
  }
}
